module.exports = __webpack_public_path__ + "static/media/all-hawkes-logos-new-hawkes-logo-eddie-black-copy.f43da36a.svg";